/* eslint-disable prefer-template */
/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-fetch';
import jwtDecode from 'jwt-decode';
import {storageAvailable, adaptPathToOs} from './Helpers';

const NOME_APP = 'Studio Web';
const NOME_APP_COMPACT = 'SW';
const VERSIONE_APP = 'v4.9.1';
const SERVER_DEBUG_MODE = false;
const API_BASE_URL_DEVELOP = 'http://api.sw.local';
const API_BASE_PORT_DEVELOP = '80';
// --- Configurazioni per debug con server locale php e xdebug attivo
//const API_BASE_URL_DEVELOP = 'http://localhost';
//const API_BASE_PORT_DEVELOP = '4000';
// --- fine cfg per xdebug
const CLIENT_BASE_PORT_DEVELOP = '3000';

const TOKEN_STORAGE_KEY = 'fsr-api-sw-auth';
const REMEMBERME_STORAGE_KEY = 'fsr-api-sw-rememberme';
const CONFIGURAZIONE_STORAGE_KEY = 'fsr-api-sw-configurazione';

// There are risks with using localStorage for API tokens in a production
// application. You open yourself up to XSS attacks. If malicious
// JavaScript makes it into your app, that JavaScript will have access
// to localStorage and therefore any sensitive tokens.

// For more info on token management, see this article:
// https://auth0.com/blog/cookies-vs-tokens-definitive-guide/

class Client {

    constructor() {
        this.apiBaseUrl = this.getApiBaseUrl();
        this.nomeApp = NOME_APP;
        this.nomeAppCompact = NOME_APP_COMPACT;
        this.versione = VERSIONE_APP;
        this.serverDebug = SERVER_DEBUG_MODE;
        this.isLocalStorage = storageAvailable('localStorage');
        this.isSessionStorage = storageAvailable('sessionStorage');
        this.rememberme = true;
        if (this.isLocalStorage && localStorage.getItem(REMEMBERME_STORAGE_KEY) !== null) {
            this.rememberme = localStorage.getItem(REMEMBERME_STORAGE_KEY) === 'true';
            this.configurazione = localStorage.getItem(CONFIGURAZIONE_STORAGE_KEY) === 'true';
        }
        this.subscribers = [];

        this.apiErrors = new Map();
        this.apiErrors.set(1, {code: 1, text: "Errore non previsto"});
        this.apiErrors.set(10, {code: 10, text: "Credenziali non valide"});
        this.apiErrors.set(11, {code: 11, text: "Token non valido"});
        this.apiErrors.set(20, {code: 20, text: "Risorsa non trovata"});

        if (this.rememberme && this.isLocalStorage) {
            this.token = localStorage.getItem(TOKEN_STORAGE_KEY);
        }
        else if (!this.rememberme && this.isSessionStorage) {
            this.token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
        }
        if (this.token) {
            this.isTokenValid().then((bool) => {
                if (!bool) {
                    this.token = null;
                }
            }).catch((error)=>{
                this.token = null;
            });
        }
        this.configurazione = {}
    }

    setConfigurazione(cfg){
        this.configurazione = cfg;
    }

    getConfigurazione(){
        return this.configurazione;

    }
    getApiBaseUrl(){
        if (!this.apiBaseUrl){
            // location.protocol, location.hostname, location.port
            if (location.hostname.indexOf("localhost") >= 0 || location.hostname.indexOf("sw.local") >= 0 || location.port === CLIENT_BASE_PORT_DEVELOP) {
                // Caso sviluppo
                this.apiBaseUrl = API_BASE_URL_DEVELOP + ":" + API_BASE_PORT_DEVELOP;
            }
            else{
                let apiHostname = "";
                if (window.API_URL){
                    apiHostname = window.API_URL;
                }
                else{
                    // Estraggo il dominio dall'hostname e ci prependo api.
                    let fields = location.hostname.split(".");
                    fields.shift();
                    apiHostname = "api." + fields.join(".");
                }
                this.apiBaseUrl = location.protocol + "//" + apiHostname + ":" + location.port;
            }
        }
        return this.apiBaseUrl;
    }

    getNomeApp(){
        return this.nomeApp;
    }
    getNomeAppCompact(){
        return this.nomeAppCompact;
    }
    getVersione(){
        return this.versione;
    }


    getDefaultRowsPerPage(){
        let cfg = this.getConfigurazione();
        if (cfg)
        {
            return cfg.righePerPagina;
        }
        else{
            return 50;
        }
    }

    getPostUrl(url) {
        let rv = this.getApiBaseUrl();
        if (this.serverDebug)
        {
            //rv += '/app_dev.php' + url;
            rv += url;
            rv += rv.indexOf("?") > 0 ? '&XDEBUG_SESSION_START=PHPSTORM' : '?XDEBUG_SESSION_START=PHPSTORM';
        }
        else {
            rv += url;
        }
        return rv;
    }

    getRememberme() {
        return this.rememberme;
    }

    isLoggedIn() {
        let rv = !!this.token;
        return rv;
    }

    subscribe(cb) {
        this.subscribers.push(cb);
    }

    notifySubscribers() {
        this.subscribers.forEach((cb) => cb(this.isLoggedIn()));
    }

    setSessionStorage(key, value){
        if (this.isSessionStorage) {
            sessionStorage.setItem(key, JSON.stringify(value))
        }
    }

    getSessionStorage(key){
        if (this.isSessionStorage) {
            let rv = sessionStorage.getItem(key);
            return JSON.parse(rv);
        }
        else {
            return null;
        }
    }

    setToken(token, rememberme) {
        this.token = token;
        this.rememberme = rememberme;

        if (this.isLocalStorage) {
            localStorage.setItem(REMEMBERME_STORAGE_KEY, rememberme ? 'true' : 'false')
        }

        if (this.rememberme && this.isLocalStorage) {
            localStorage.setItem(TOKEN_STORAGE_KEY, token);
        }
        else if (!this.rememberme && this.isSessionStorage) {
            sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
        }
    }

    getCurrentUserId()
    {
        let data = jwtDecode(this.token);
        return data["id_utente"];
    }

    isCurrentUserAdmin()
    {
        let data = jwtDecode(this.token);
        return data["isadmin"];
    }

    getCurrentUser()
    {
        let data = jwtDecode(this.token);
        return {
            idUtente: data["id_utente"],
            username: data["username"],
            email: data["email"],
            nome: data["nome"],
            isadmin: data["isadmin"],
            isroleattivita: data["isroleattivita"],
            isrolegare: data["isrolegare"],
            isrolegarew: data["isrolegarew"],
            isrolecommesse: data["isrolecommesse"],
            isrolecommessew: data["isrolecommessew"],
            isroledocumenti: data["isroledocumenti"],
            isroledocumentiw: data["isroledocumentiw"],
            isrolerubrica: data["isrolerubrica"],
            isrolerubricaw: data["isrolerubricaw"],
            isrolemovimenti: data["isrolemovimenti"],
            isrolemovimentiw: data["isrolemovimentiw"],
            isrolemovimentiext: data["isrolemovimentiext"],
            isrolereport: data["isrolereport"],
            isroleconfigurazione: data["isroleconfigurazione"],
            isrolenews: data["isrolenews"],
            isrolenewsw: data["isrolenewsw"],
            bckcolor1: data["bckcolor1"],
            bckcolor2: data["bckcolor2"],
            imgprofilo: data["imgprofilo"],
        };
    }

    removeToken() {
        this.token = null;

        if (this.rememberme && this.isLocalStorage) {
            localStorage.removeItem(TOKEN_STORAGE_KEY);
        }
        else if (!this.rememberme && this.isSessionStorage) {
            sessionStorage.removeItem(TOKEN_STORAGE_KEY);
        }
    }

    isTokenValid() {
        // See note about tokens above
        const url = this.getApiBaseUrl() + '/api/check_token?token=' + this.token;
        return fetch(url, {
            method: 'get',
            headers: {
                accept: 'application/json',
            },
        }).then(this.checkStatus)
        .then(this.parseJson)
        .then((json) => json.valid === true)
        .catch((error) => {
            if (error.status !== undefined)
            {
                const newerr = new Error('Fetch Error: ' + error.internalText);
                switch (error.status) {
                    case 401:
                    case 404:
                        newerr.internalErrorText = error.internalText;
                        newerr.api = this.apiErrors.get(10);
                        break;
                    default:
                        newerr.internalErrorText = error.internalText;
                        newerr.api = this.apiErrors.get(1);
                        break;
                }
                throw newerr;
            }
            else
            {
                const newerr = new Error('Fetch Error: ' + error);
                newerr.internalErrorText = error;
                newerr.api = this.apiErrors.get(1);
                newerr.status = 500;
                throw newerr;
            }

        });
    }

    login(username, password, rememberme) {
        return fetch(this.getApiBaseUrl() + '/login', {
            method: 'post',
            body: JSON.stringify({
                "_username": username,
                "_password": password
            }),
            headers: {
                accept: 'application/json',
            },
        }).then((response) => this.checkStatus(response))
            .then(this.parseJson)
            .then((json) => {
                sessionStorage.clear();
                this.setToken(json.token, rememberme)
            }).catch((error) => {
                if (error.status !== undefined)
                {
                    const newerr = new Error('Fetch Error: ' + error.internalText);
                    switch (error.status) {
                        case 401:
                        case 404:
                            newerr.internalErrorText = error.internalText;
                            newerr.api = this.apiErrors.get(10);
                            break;
                        default:
                            newerr.internalErrorText = error.internalText;
                            newerr.api = this.apiErrors.get(1);
                            break;
                    }
                    throw newerr;
                }
                else
                {
                    const newerr = new Error('Fetch Error: ' + error);
                    newerr.internalErrorText = error;
                    newerr.api = this.apiErrors.get(1);
                    newerr.status = 500;
                    throw newerr;
                }

            });
    }

    logout() {
        this.removeToken();
        sessionStorage.clear();
    }

    checkStatus(response) {
        if (response.ok) {
            return response;
        }
        throw new Error('Errore di rete inatteso ['+response.status+']');
    }

    checkApiError(response) {
        if (response.status === undefined || (response.status >= 200 && response.status < 300)) {
            return response;
        }
        const error = new Error(`API Error ${response.type}`);
        error.status = response.status;
        error.type = response.type;
        error.title = response.title;
        error.errors = response.errors;
        throw error;
    }

    parseJson(response) {
        return response.json();
    }

    adaptClientPath(path){
        return adaptPathToOs(path);
    }

    getCommesseOrderingStandard(removeSeparator) {

        return (removeSeparator ? '' : '&') + 'order=priorita,A|codice,A|nome,A';
    }
    getNewsOrderingStandard(removeSeparator) {

        return (removeSeparator ? '' : '&') + 'order=dataPubblicazione,D|idNews,D';
    }
    getGareOrderingStandard(removeSeparator) {

        return (removeSeparator ? '' : '&') + 'order=anno,D|codice,A|nome,A';
    }
    getUtentiOrderingStandard(removeSeparator) {

        return (removeSeparator ? '' : '&') + 'order=idUtente,A';
    }


    loadCommesseList(rowsPerPage, currentPage, orderInfo, filterInfo) {

        let url = '/api/commesse?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }

        // 03/05/2020 Emanuele: se non c'è orderInfo, applico l'ordinamento standard, altrimenti applico quello richiesto
        // 30/04/2020 Emanuele: come da richiesta, ripristinato l'ordinamento per colonna
        // // 16/07/2018 Emanuele: come richiestio le commesse hanno sempre l'ordinamento std
        // url += this.getCommesseOrderingStandard();
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        else {
            url += this.getCommesseOrderingStandard();
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }
        if (filterInfo !== undefined && filterInfo.isChiusa !== undefined ) {
            url += ('&concluse=' + (filterInfo.isChiusa ? 1 : 0));
        }
        if (filterInfo !== undefined && filterInfo.isArchiviata !== undefined ) {
            url += ('&archiviate=' + (filterInfo.isArchiviata ? 1 : 0));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    deleteCommessa(commessa) {
        let url = this.getPostUrl('/api/commesse/'+commessa.idCommessa);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }


    loadCommesseAttiveIlList(data) {

        let url = '/api/commesse?attiveIl='+data + this.getCommesseOrderingStandard() + "&rowsPerPage=999999";
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadCommesseNonChiuseList() {

        let url = "/api/commesse?concluse=0&page=-1" + this.getCommesseOrderingStandard();
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadCommesseNonArchiviateList() {

        let url = "/api/commesse?archiviate=0&page=-1" + this.getCommesseOrderingStandard();
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadTipiGaraList() {
        let url = "/api/tipigara?page=-1&order=descrizione,D";
        
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadCommesseTutteList() {

        let url = "/api/commesse?page=-1" + this.getCommesseOrderingStandard();
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadGareTutteList() {

        let url = "/api/gare?page=-1" + this.getGareOrderingStandard();
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadCommesseTutteListPerPeriodoUtente(dataDal, dataAl, idUtente) {

        let url = "/api/commesseconattivita?page=-1" + this.getCommesseOrderingStandard() + 'page=-1&inizio=' + dataDal + '&fine=' + dataAl + '&idutente=' + idUtente;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadGareList(rowsPerPage, currentPage, orderInfo, filterInfo) {

        let url = '/api/gare?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }

        //url += this.getGareOrderingStandard();
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }
        if (filterInfo !== undefined && filterInfo.keywordAnno !== undefined) {
            url += ('&filterAnno=' + encodeURIComponent(filterInfo.keywordAnno));
        }
        if (filterInfo !== undefined && filterInfo.keywordNote !== undefined) {
            url += ('&filterNote=' + encodeURIComponent(filterInfo.keywordNote));
        }
        if (filterInfo !== undefined && filterInfo.statoInCommessa !== undefined ) {
            if (filterInfo.statoInCommessa !== -1){
                url += ('&trasformate=' + filterInfo.statoInCommessa );
            }
        }
        if (filterInfo !== undefined && filterInfo.statoPartecipato !== undefined ) {
            if (filterInfo.statoPartecipato !== -1){
                url += ('&partecipato=' + filterInfo.statoPartecipato );
            }
        }
        if (filterInfo !== undefined && filterInfo.statoGara !== undefined ) {
            if (filterInfo.statoGara !== 'ALL'){
                url += ('&statoGara=' + filterInfo.statoGara );
            }
        }
        if (filterInfo !== undefined && filterInfo.keywordCodiceCompleto !== undefined) {
            url += ('&filterCodiceCompleto=' + encodeURIComponent(filterInfo.keywordCodiceCompleto));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    deleteGara(gara) {
        let url = this.getPostUrl('/api/gare/'+gara.idGara);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    loadRubricaList(rowsPerPage, currentPage, orderInfo, filterInfo, filterExt, filterTipo) {

        let url = '/api/soggetti?page='+currentPage;
        if (rowsPerPage !== undefined) {
            url += ('&rowsPerPage=' + rowsPerPage);
        }
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }

        let filterExtList = [];

        if (filterExt !== undefined && filterExt.tipo !== undefined && filterExt.lettera !== 'All'){
            let nome = 'nome';
            if (filterExt.tipo === 's'){
                nome = 'cognome';
            }
            // url = url + '&filterext=' + filterExt.tipo +'.' + nome + ',like,'+filterExt.lettera+'%';
            filterExtList.push(filterExt.tipo +'.' + nome + ',like,'+filterExt.lettera+'%');
        }
        if (filterExtList.length > 0){
            url += ('&filterext=' + filterExtList.join('|'))
        }

        let filterNamesList = [];

        if (filterInfo !== undefined && filterInfo.soggetto !== undefined && filterInfo.soggetto.length > 0 ) {
            filterNamesList.push(encodeURIComponent('soggetto:'+filterInfo.soggetto));
        }
        if (filterInfo !== undefined && filterInfo.dipartimento !== undefined  && filterInfo.dipartimento.length > 0) {
            filterNamesList.push(encodeURIComponent('dipartimento:'+filterInfo.dipartimento));
        }
        if (filterInfo !== undefined && filterInfo.organizzazione !== undefined  && filterInfo.organizzazione.length > 0) {
            filterNamesList.push(encodeURIComponent('organizzazione:'+filterInfo.organizzazione));
        }
        if (filterInfo !== undefined && filterInfo.telefono !== undefined  && filterInfo.telefono.length > 0) {
            filterNamesList.push(encodeURIComponent('telefono:'+filterInfo.telefono));
        }
        if (filterInfo !== undefined && filterInfo.email !== undefined  && filterInfo.email.length > 0) {
            filterNamesList.push(encodeURIComponent('email:'+filterInfo.email));
        }
        if (filterNamesList.length > 0){
            url += ('&filternames=' + filterNamesList.join('|'))
        }

        if (filterTipo !== undefined && filterTipo !== null){
            url += ('&filterTipo='+filterTipo.isProspect+','+filterTipo.isCliente+','+filterTipo.isFornitore+','+filterTipo.isTp);
        }

        let conditions = this.getCondizioniAggiuntive(filterInfo.conditions, filterInfo.multiFilter);
        if (conditions !== undefined && conditions !== ''){
            url += '&conditions='+encodeURIComponent(conditions);
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    //    loadRubricaList(rowsPerPage, currentPage, orderInfo, filterInfo, filterExt, filterTipo) {

    exportRubricaList(orderInfo, filterInfo, filterExt, filterTipo, tipo) {

        let url = '/api/export/soggetti?format=' + tipo
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }
        let filterExtList = [];

        if (filterExt !== undefined && filterExt.tipo !== undefined && filterExt.lettera !== 'All'){
            let nome = 'nome';
            if (filterExt.tipo === 's'){
                nome = 'cognome';
            }
            // url = url + '&filterext=' + filterExt.tipo +'.' + nome + ',like,'+filterExt.lettera+'%';
            filterExtList.push(filterExt.tipo +'.' + nome + ',like,'+filterExt.lettera+'%');
        }
        if (filterExtList.length > 0){
            url = url + '&filterext=' + filterExtList.join('|')
        }

        let filterNamesList = [];

        if (filterInfo !== undefined && filterInfo.soggetto !== undefined && filterInfo.soggetto.length > 0 ) {
            filterNamesList.push(encodeURIComponent('soggetto:'+filterInfo.soggetto));
        }
        if (filterInfo !== undefined && filterInfo.dipartimento !== undefined  && filterInfo.dipartimento.length > 0) {
            filterNamesList.push(encodeURIComponent('dipartimento:'+filterInfo.dipartimento));
        }
        if (filterInfo !== undefined && filterInfo.organizzazione !== undefined  && filterInfo.organizzazione.length > 0) {
            filterNamesList.push(encodeURIComponent('organizzazione:'+filterInfo.organizzazione));
        }
        if (filterInfo !== undefined && filterInfo.telefono !== undefined  && filterInfo.telefono.length > 0) {
            filterNamesList.push(encodeURIComponent('telefono:'+filterInfo.telefono));
        }
        if (filterInfo !== undefined && filterInfo.email !== undefined  && filterInfo.email.length > 0) {
            filterNamesList.push(encodeURIComponent('email:'+filterInfo.email));
        }
        if (filterNamesList.length > 0){
            url = url + '&filternames=' + filterNamesList.join('|')
        }

        if (filterTipo !== undefined && filterTipo !== null){
            url = url + '&filterTipo='+filterTipo.isProspect+','+filterTipo.isCliente+','+filterTipo.isFornitore+','+filterTipo.isTp;
        }

        let conditions = this.getCondizioniAggiuntive(filterInfo.conditions, filterInfo.multiFilter);
        if (conditions !== undefined && conditions !== ''){
            url += '&conditions='+encodeURIComponent(conditions);
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    loadDocumentiList(rowsPerPage, currentPage, orderInfo, filterInfo) {

        let url = '/api/documenti?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url = url + orderInfo[i].field + ','+ orderInfo[i].direction;
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + filterInfo.keyword;
        }
        if (filterInfo !== undefined && filterInfo.anno !== undefined) {
            url = url + '&anno=' + filterInfo.anno;
        }
        if (filterInfo !== undefined && filterInfo.codiceTipoDocumento !== undefined && filterInfo.codiceTipoDocumento !== "-1") {
            url = url + '&tipodoc=' + filterInfo.codiceTipoDocumento;
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadComandiServerList(rowsPerPage, currentPage, orderInfo, filterInfo) {

        let url = '/api/comandiserver?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + filterInfo.keyword;
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadDocumentiByCommessaList(idCommessa) {

        let url = '/api/documentifs?idc='+idCommessa;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadDocumentiPiuRecentiPerTipoList() {

        let url = '/api/documentipiurecentepertipo';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadUtente(idUtente) {

        let url = this.getPostUrl('/api/utenti/'+idUtente);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveUtente(fields, id) {

        let url = '/api/utenti';
        let method = 'post';
        if (id !== undefined) {
            url = url + "/" + id;
            method = 'put';
        }

        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })

    }

    updateUtente(fields, id) {
        let url = this.getPostUrl('/api/utenti/' + id);

        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    loadCommessa(idCommessa) {

        let url = this.getPostUrl('/api/commesse/'+idCommessa);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveCommessa(fields, id, idGara) {

        let url = '/api/commesse';
        let method = 'post';
        if (id !== undefined) {
            url = url + "/" + id;
            method = 'put';
        }
        if (idGara !== undefined) {
            fields["idGara"] = idGara;
            fields["modificatoDa"] = this.getCurrentUserId();
        }
        if (id !== undefined){
            fields["modificatoDa"] = this.getCurrentUserId();
        }
        else {
            fields["creatoDa"] = this.getCurrentUserId();
        }

        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })

    }

    updateCommessa(fields, id) {
        let url = this.getPostUrl('/api/commesse/' + id);

        if (id !== undefined){
            fields["modificatoDa"] = this.getCurrentUserId();
        }

        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }



    loadGara(idGara) {

        let url = this.getPostUrl('/api/gare/'+idGara);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveGara(fields, id) {
        let url = '/api/gare';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
            fields["modificatoDa"] = this.getCurrentUserId();
        } else{
            fields["creatoDa"] = this.getCurrentUserId();
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })

    }

    updateGara(fields, id) {
        let url = this.getPostUrl('/api/gare/' + id);
        if (id !== undefined){
            fields["modificatoDa"] = this.getCurrentUserId();
        }
        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveDocumento(fields, id) {
        let url = '/api/documenti';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })

    }

    deleteDocumento(documento) {
        let url = this.getPostUrl('/api/documenti/'+documento.idDocumento);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    comandiServerExecute(comando) {
        let url = this.getPostUrl('/api/comandiserver/execute/'+comando.idComandoServer);
        return fetch(url, {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            }
        })
    }

    downloadDocument(idDocumento) {

        let url = this.getPostUrl('/api/download/'+idDocumento);
        return fetch(url, {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    downloadFile(nome, path) {
        let data = {nome, path};
        let url = this.getPostUrl('/api/download');
        return fetch(url, {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    /**
     * Si aspetta una struttura del tipo:
     *
     * {
     *   type: db/fs
     *   folder: nome della cartella
     *   item: Documenti entity/File system info (nome,size,path,mtype - vedere listFsCommessaAction)
     * }
     *
     * @param doctype
     * @returns {*}
     */
    download(doctype){

        if (doctype.infs)
        {
            return this.downloadFile(doctype.item.nome, doctype.item.path);
        }
        else
        {
            return this.downloadDocument(doctype.item.idDocumento);
        }
    }

    loadRubrica(idSoggetto) {

        let url = this.getPostUrl('/api/soggetti/'+idSoggetto);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    deleteRubrica(soggetto) {
        let url = this.getPostUrl('/api/soggetti/'+soggetto.idSoggetto);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    saveRubrica(fields, id) {
        let url = '/api/soggetti';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
            fields["soggetto"]["modificatoDa"] = this.getCurrentUserId()
        }
        else{
            fields["soggetto"]["creatoDa"] = this.getCurrentUserId()
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }


    loadOrganizzazioniList(rowsPerPage, currentPage, orderInfo, filterInfo, escludiDefault = false) {

        let url = '/api/organizzazioni?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        // if (orderInfo !== undefined && orderInfo.field !== undefined){
        //     url = url + '&order='+ orderInfo.field + ','+ orderInfo.direction;
        // }

        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url = url + orderInfo[i].field + ','+ orderInfo[i].direction;
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }

        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + encodeURIComponent(filterInfo.keyword);
        }
        let filterNamesList = [];
        if (filterInfo !== undefined && filterInfo.mostraOrfani !== undefined) {
            filterNamesList.push(encodeURIComponent('mostraOrfani:'+filterInfo.mostraOrfani));
        }
        if (escludiDefault) {
            filterNamesList.push(encodeURIComponent('escludiOrganizzazione:' + this.getConfigurazione().idDipartimento.idOrganizzazione.idOrganizzazione));
        }

        if (filterNamesList.length > 0){
            url = url + '&filternames=' + filterNamesList.join('|')
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadOrganizzazione(idOrganizzazione) {

        let url = this.getPostUrl('/api/organizzazioni/'+idOrganizzazione);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    deleteOrganizzazione(organizzazione) {
        let url = this.getPostUrl('/api/organizzazioni/'+organizzazione.idOrganizzazione);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }


    loadSoggettiTitoliList(){
        let url = '/api/titoli?rowsPerPage=999999&order=titolo,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadPianoDeiContiAllList(){
        let url = '/api/pianodeiconti?rowsPerPage=999999&order=catDesc,A|voxDesc,A|subDesc,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }



    loadPianoDeiContiAllListLiv1(filter){
        let url = '/api/pianodeiconti/liv1';
        if (filter){
            url += '?filter=' + filter;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }
    loadPianoDeiContiAllListLiv2(cod, filter){
        let url = '/api/pianodeiconti/liv2/'+cod;
        if (filter){
            url += '?filter=' + filter;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }
    loadPianoDeiContiAllListLiv3(cod1, cod2, filter){
        let url = '/api/pianodeiconti/liv3/' + cod1 + '/' + cod2;
        if (filter){
            url += '?filter=' + filter;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadPianoDeiConti(idPdc) {

        let url = this.getPostUrl('/api/pianodeiconti/'+idPdc);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    loadUtentiList(rowsPerPage, currentPage, orderInfo, filterInfo, userId) {

        let url = '/api/utenti?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }

        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        else {
            url += this.getUtentiOrderingStandard();
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }
        if (filterInfo !== undefined && filterInfo.attivo !== undefined ) {
            url += ('&attivo=' + filterInfo.attivo );
        }
        if (userId !== undefined) {
            url += ('&userId=' + userId );
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadUtentiAllList(){
        let url = '/api/utenti?page=-1&order=nome,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadUtentiAllConAttivitaList(dataDal, dataAl){
        let url = '/api/utenticonattivita?page=-1&order=nome,A&inizio=' + dataDal + '&fine=' + dataAl;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    deleteUtente(utente) {
        let url = this.getPostUrl('/api/utenti/'+utente.idUtente);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    saveOrganizzazione(fields, id) {
        let url = '/api/organizzazioni';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
            fields["modificatoDa"] = this.getCurrentUserId()
        }
        else{
            fields["creatoDa"] = this.getCurrentUserId()
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    loadDipartimentiList(rowsPerPage, currentPage, orderInfo, filterInfo, escludiDefault = false) {

        let url = '/api/dipartimenti?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        // if (orderInfo !== undefined && orderInfo.field !== undefined){
        //     url = url + '&order='+ orderInfo.field + ','+ orderInfo.direction;
        // }
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url = url + orderInfo[i].field + ','+ orderInfo[i].direction;
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }

        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + encodeURIComponent(filterInfo.keyword);
        }

        let filterNamesList = [];
        if (filterInfo !== undefined && filterInfo.dipartimento !== undefined  && filterInfo.dipartimento.length > 0) {
            filterNamesList.push(encodeURIComponent('dipartimento:'+filterInfo.dipartimento));
        }
        if (filterInfo !== undefined && filterInfo.organizzazione !== undefined  && filterInfo.organizzazione.length > 0) {
            filterNamesList.push(encodeURIComponent('organizzazione:'+filterInfo.organizzazione));
        }
        if (filterInfo !== undefined && filterInfo.mostraOrfani !== undefined) {
            filterNamesList.push(encodeURIComponent('mostraOrfani:'+filterInfo.mostraOrfani));
        }
        if (escludiDefault) {
            filterNamesList.push(encodeURIComponent('escludiDipartimento:' + this.getConfigurazione().idDipartimento.idDipartimento));
        }
        if (filterNamesList.length > 0){
            url = url + '&filternames=' + filterNamesList.join('|')
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadDipartimentiByOrganizzazione(idOrganizzazione) {

        let url = '/api/dipartimenti?rowsPerPage=999999&order=d.nome,A&filter=idOrganizzazione=' + idOrganizzazione;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadDipartimento(idDipartimento) {

        let url = this.getPostUrl('/api/dipartimenti/'+idDipartimento);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    saveDipartimento(fields, id) {
        let url = '/api/dipartimenti';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
            fields["modificatoDa"] = this.getCurrentUserId()
        }
        else{
            fields["creatoDa"] = this.getCurrentUserId()
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    deleteDipartimento(dipartimento) {
        let url = this.getPostUrl('/api/dipartimenti/'+dipartimento.idDipartimento);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    loadDivisioniList(rowsPerPage, currentPage, orderInfo, filterInfo, inRubrica, inCommesse, inGare) {

        let url = '/api/divisioni?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        if (orderInfo !== undefined && orderInfo.field !== undefined){
            url = url + '&order='+ orderInfo.field + ','+ orderInfo.direction;
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + filterInfo.keyword;
        }
        if(inRubrica !== undefined && inRubrica === true){
            url += '&inRubrica=true';
        }
        if(inCommesse !== undefined && inCommesse === true){
            url +=  '&inCommesse=true';
        }
        if(inGare !== undefined && inGare === true){
            url +=  '&inGare=true';
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadTipiDocumentoList(rowsPerPage, currentPage, orderInfo, filterInfo, inRubrica, inCommesse, inGare) {

        let url = '/api/tipidocumento?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        if (orderInfo !== undefined && orderInfo.field !== undefined){
            url = url + '&order='+ orderInfo.field + ','+ orderInfo.direction;
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + filterInfo.keyword;
        }
        if(inRubrica !== undefined && inRubrica === true){
            url += '&inRubrica=true';
        }
        if(inCommesse !== undefined && inCommesse === true){
            url +=  '&inCommesse=true';
        }
        if(inGare !== undefined && inGare === true){
            url +=  '&inGare=true';
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadTipiDocumentoTuttiList() {
        let url = '/api/tipidocumento?page=-1&order=nome,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    getCondizioniAggiuntive(conditionString, multiFilterArray){

        let condizioni = [];
        let i;
        if (multiFilterArray && multiFilterArray.length > 0){
            for(i=0; i<multiFilterArray.length ; i++){
                let it = JSON.parse(multiFilterArray[i]);
                condizioni.push("(" + it.valore + ")")
            }
        }
        if (conditionString)
        {
            condizioni.push(conditionString);
        }
        if (condizioni.length > 0){
            return  condizioni.join(" AND ");

        }else{
            return '';
        }
    }

    loadMovimentiList(rowsPerPage, currentPage, orderInfo, filterInfo) {
        let url = this.loadMovimentiListGetUrl('/api/movimenti?page='+currentPage, rowsPerPage, orderInfo, filterInfo);
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportMovimentiList(orderInfo, filterInfo, tipo) {
        let url = this.loadMovimentiListGetUrl('/api/export/movimenti?format=' + tipo, -1, orderInfo, filterInfo);
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    /**
     * 
     * @param {*} filterInfo 
     * @param {*} format csv|xlsx
     * @returns 
     */
    exportMovimentiPerBudget(filterInfo, format) {
        let url = this.loadMovimentiListGetUrl('/api/export/movimentiperbudget?format='+format, -1, [], filterInfo);
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    loadMovimentiListGetUrl(urlBase, rowsPerPage, orderInfo, filterInfo) {

        let url = urlBase;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }
        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url = url + orderInfo[i].field + ','+ orderInfo[i].direction;
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url = url + '&filter=' + encodeURIComponent(filterInfo.keyword);
        }
        if (filterInfo !== undefined && filterInfo.keywordCommessa !== undefined) {
            url = url + '&filterCommessa=' + encodeURIComponent(filterInfo.keywordCommessa);
        }
        let filterExt = [];
        if (filterInfo !== undefined && filterInfo.entrUsc !== undefined && filterInfo.entrUsc !== 'All') {
            filterExt.push('m.entrUsc,=,'+filterInfo.entrUsc);
        }
        if (filterInfo !== undefined && filterInfo.dataStart !== undefined) {
            filterExt.push('m.data,>=,'+filterInfo.dataStart);
        }
        if (filterInfo !== undefined && filterInfo.dataEnd !== undefined) {
            filterExt.push('m.data,<=,'+filterInfo.dataEnd);
        }
        if (filterInfo !== undefined && filterInfo.ecStart !== undefined && filterInfo.ecStart !== "" && filterInfo.ecStart !== null) {
            filterExt.push('m.estrConto,>=,'+filterInfo.ecStart);
        }
        if (filterInfo !== undefined && filterInfo.ecEnd !== undefined && filterInfo.ecEnd !== "" && filterInfo.ecEnd !== null) {
            filterExt.push('m.estrConto,<=,'+filterInfo.ecEnd);
        }
        if (filterExt.length > 0){
            url = url + '&filterext=' + encodeURIComponent(filterExt.join('|'));
        }

        let conditions = this.getCondizioniAggiuntive(filterInfo.conditions, filterInfo.multiFilter);
        if (conditions !== undefined && conditions !== ''){
            url += '&conditions='+encodeURIComponent(conditions);
        }
        return url;
    }


    loadMovimento(idMovimento) {

        let url = this.getPostUrl('/api/movimenti/'+idMovimento);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }
    saveMovimento(fields, id) {
        let url = '/api/movimenti';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
            fields["modificatoDa"] = this.getCurrentUserId();
        } else{
            fields["creatoDa"] = this.getCurrentUserId();
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })

    }
    updateMovimento(fields, id) {
        let url = this.getPostUrl('/api/movimenti/' + id);
        fields["modificatoDa"] = this.getCurrentUserId()
        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }


    deleteMovimento(movimento) {
        let url = this.getPostUrl('/api/movimenti/'+movimento.idMovimento);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }



    // loadTestiPerTipoList(tipo, valore = ''){
    //     let url = '/api/testi?filterext=t.tipo,=,' + tipo + '|t.valore,like,' + valore + '%&order=valore,A';
    //     return fetch(this.getPostUrl(url), {
    //         method: 'get',
    //         headers: {
    //             accept: 'application/json',
    //             authorization: 'Bearer ' + this.token
    //         },
    //     });
    // }
    loadTestiPerTipoList(tipo, valore = ''){
        let url = '/api/testipertipo?tipo=' + tipo + '&valore=' + valore + '%&order=valore,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadFiltriPerTipoList(tipo, valore = ''){
        let url = '/api/filtripertipo?tipo=' + tipo + '&order=nome,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadAttivitaUtenteChiuse(userId, giorno){
        let url = '/api/attivita?rowsPerPage=999999&filterext=a.idUtente,=,' + userId + '|a.giorno,=,' + giorno + '|a.fine,!=,null&order=a.inizio,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadAttivitaUtente(userId, giorno){
        let url = '/api/attivita?rowsPerPage=999999&filterext=a.idUtente,=,' + userId + '|a.giorno,=,' + giorno + '&order=a.inizio,A';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    saveTestiPerTipo(tipo, valore) {
        let fields = {
            tipo: tipo,
            valore: valore,
            attivo: 1
        }
        let url = '/api/testi';
        return fetch(this.getPostUrl(url), {
            method: 'post',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    /**
     * Una volta caricata la cfg, esse viene passata come primo parametro
     * alla callback.
     * In caso di errore il primo parametro è undefined e il secondo contiene l'errore.
     *
     * @param callback
     */
    loadConfigurazione(callback) {

        let url = this.getPostUrl('/api/configurazione');
        fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
            },
        }).then(
            (response) => {
                if (response.ok){
                    response.json().then((cfg) => {
                        if (callback !== undefined) {
                            callback(cfg);
                        }
                    })
                }
                else {
                    if (callback !== undefined) {
                        callback(undefined, response);
                    }
                }
            }).catch((error) => {

                if (callback !== undefined) {
                    callback(undefined, error);
                }
        });
    }

    exportCSVSoggettiList(idList) {

        let url = this.getPostUrl('/api/export/soggetti?idlist='+idList.join());
        return fetch(url, {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    saveAttivita(fields, id) {
        let url = '/api/attivita';
        let method = 'post';
        if (id !== undefined){
            url = url + "/" + id;
            method = 'put';
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    /**
     *
     * @param fields Attività sovrapposta da creare
     * @param id Id dell'attività da modificare con i pesi presenti in fields
     */
    saveAttivitaSovrapposte(fields, id) {
        let url = '/api/attivitasovrapposta/' + id;
        let method = 'post';
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    updateAttivita(fields, id) {
        let url = this.getPostUrl('/api/attivita/' + id);
        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }
    deleteAttivita(attivita) {
        let url = this.getPostUrl('/api/attivita/'+attivita.idAttivita);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    loadStatsPrevdays(userId, giorno, numgg){
        let url = '/api/stats/prevdays?idUtente=' + userId + '&giorno=' + giorno + '&numgg=' + numgg;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadStatsRiepilogoPerCommessa(userId, giorno){
        let url = '/api/stats/totcommperday?idUtente=' + userId + '&giorno=' + giorno;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportMovimenti(filterInfo){

        let url = '/api/stats/reportmovimenti?da=' + filterInfo.dataStart + '&a=' + filterInfo.dataEnd;

        let conditions = this.getCondizioniAggiuntive(filterInfo.conditions, filterInfo.multiFilter);
        if (conditions !== undefined && conditions !== ''){
            url += '&conditions='+encodeURIComponent(conditions);
        }

        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportAttivita(idUtente, dataInizio, dataFine, idCommessa, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/stats/reportattivita?idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportReportAttivita(idUtente, dataInizio, dataFine, idCommessa, tipo, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/export/reportattivita?format=' + tipo + '&idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportAttivitaAnnuale(idUtente, dataInizio, dataFine, idCommessa, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/stats/reportattivitaannuale?idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportReportAttivitaAnnuale(idUtente, dataInizio, dataFine, idCommessa, tipo, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/export/reportattivitaannuale?format=' + tipo + '&idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportAttivitaGiornaliero(idUtente, dataInizio, dataFine, idCommessa, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/stats/reportattivitagiornaliero?idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportReportAttivitaGiornaliero(idUtente, dataInizio, dataFine, idCommessa, tipo, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/export/reportattivitagiornaliero?format=' + tipo + '&idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportAttivitaDettagliato(idUtente, dataInizio, dataFine, idCommessa, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/stats/reportattivitadettagliato?idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportReportAttivitaDettagliato(idUtente, dataInizio, dataFine, idCommessa, tipo, keyword){
        if (idUtente === undefined){
            idUtente = 0;
        }
        if (idCommessa === undefined){
            idCommessa = 0;
        }
        let url = '/api/export/reportattivitadettagliato?format=' + tipo + '&idUtente=' + idUtente + '&idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        if (keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(keyword));
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommesseGaraLavoratori(idCommessa){
        let url = '/api/stats/reportcommesse/garalavoratori?idCommessa=' + idCommessa;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommesseLavoratori(idCommessa, dataInizio, dataFine){
        let url = '/api/stats/reportcommesse/lavoratori?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommessePrevisionale(idCommessa, dataInizio, dataFine){
        let url = '/api/stats/reportcommesse/previsionale?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommesseCostidiretti(idCommessa, dataInizio, dataFine){
        let url = '/api/stats/reportcommesse/costidiretti?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommesseFattureProforme(tipo, idCommessa, dataInizio, dataFine){

        if (tipo === 'F')
        {
            let url = '/api/stats/reportcommesse/fatture?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
            return fetch(this.getPostUrl(url), {
                method: 'get',
                headers: {
                    accept: 'application/json',
                    authorization: 'Bearer ' + this.token
                },
            });

        }
        else {
            let url = '/api/stats/reportcommesse/proforme?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
            return fetch(this.getPostUrl(url), {
                method: 'get',
                headers: {
                    accept: 'application/json',
                    authorization: 'Bearer ' + this.token
                },
            });

        }
    }

    loadReportCommesseCostiindiretti(idCommessa, dataInizio, dataFine){
        let url = '/api/stats/reportcommesse/costiindiretti?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadReportCommesseDocumenti(idCommessa, dataInizio, dataFine){
        let url = '/api/stats/reportcommesse/documenti?idCommessa=' + idCommessa + '&da=' + dataInizio + '&a=' + dataFine;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadCommessaMaxMinDate(idCommessa){
        let url = '/api/commessemaxmindate?idCommessa=' + idCommessa;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    saveChartRiepilogoOrario(chartData) {
        let fields = {
            img: chartData,
            userid: this.getCurrentUserId()
        }
        let url = '/api/chartriepilogoorario';
        let method = 'post';
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    spostaAttivita(idUtente, dataInizio, dataFine) {
        let fields = {
            userid: idUtente,
            dt_src: dataInizio,
            dt_dst: dataFine
        }
        let url = '/api/attivitasposta';
        let method = 'post';
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    loadDocumentiAssegnabiliAMovimenti(){
        let url = '/api/docinmov';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    updateDocumentoInMovimento(fields, id) {
        let url = this.getPostUrl('/api/docinmov/' + id);
        fields["modificatoDa"] = this.getCurrentUserId()
        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    downloadDocumentInMovimento(idMovimento) {

        let url = this.getPostUrl('/api/docinmov/'+idMovimento);
        return fetch(url, {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        })
    }

    deleteDocumentoInMovimento(movimento) {
        let url = this.getPostUrl('/api/docinmov/'+movimento.idMovimento);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    caricaPathDocumento(movimento){
        let url = '/api/docinmovpath';
        return fetch(this.getPostUrl(url+ '/'+ movimento.idMovimento), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    previewDocumentoInMovimento(movimento = null, filename = null){
        if (movimento !== null){
            return this.previewDocumentoInMovimentoByMovimento(movimento);
        }
        else
        {
            return this.previewDocumentoInMovimentoByFilename(filename);
        }

    }
    previewDocumentoInMovimentoByMovimento(movimento){
        let url = '/api/docinmovpreview';
        return fetch(this.getPostUrl(url+ '/'+ movimento.idMovimento), {
            method: 'get',
            headers: {
                authorization: 'Bearer ' + this.token
            },
        });
    }

    previewDocumentoInMovimentoByFilename(fileName){
        let url = '/api/docmovtochoosepreview';
        return fetch(this.getPostUrl(url+ '/'+ fileName), {
            method: 'get',
            headers: {
                authorization: 'Bearer ' + this.token
            },
        });
    }


    loadReportReddittivitaCommesse(){
        let url = '/api/stats/reportreddittivitacommesse';
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    exportReportReddittivitaCommesse(tipo){
        let url = '/api/export/reportreddittivitacommesse?format='+tipo;
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                authorization: 'Bearer ' + this.token
            },
        });
    }


    loadNewsList(rowsPerPage, currentPage, orderInfo, filterInfo, userId) {

        let url = '/api/news?page='+currentPage;
        if (rowsPerPage !== undefined && rowsPerPage > 0) {
            url = url + '&rowsPerPage=' + rowsPerPage;
        }

        if (orderInfo !== undefined && orderInfo.length > 0){
            url += '&order=';
            for(let i=0; i<orderInfo.length; i++){
                url += (orderInfo[i].field + ','+ orderInfo[i].direction);
                if (i < orderInfo.length-1){
                    url += '|';
                }
            }
        }
        else {
            url += this.getNewsOrderingStandard();
        }
        if (filterInfo !== undefined && filterInfo.keyword !== undefined) {
            url += ('&filter=' + encodeURIComponent(filterInfo.keyword));
        }
        if (filterInfo !== undefined && filterInfo.statoNews !== undefined ) {
            url += ('&visibile=' + filterInfo.statoNews );
        }
        if (userId !== undefined) {
            url += ('&userId=' + userId );
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    deleteNews(news) {
        let url = this.getPostUrl('/api/news/'+news.idNews);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }

    loadNews(idNews) {

        let url = this.getPostUrl('/api/news/'+idNews);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveNews(fields, id) {

        let url = '/api/news';
        let method = 'post';
        if (id !== undefined) {
            url = url + "/" + id;
            method = 'put';
        }
        if (id !== undefined){
            fields["modificatoDa"] = this.getCurrentUserId();
        }
        else {
            fields["creatoDa"] = this.getCurrentUserId();
        }
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    updateNews(fields, id) {
        let url = this.getPostUrl('/api/news/' + id);

        if (id !== undefined){
            fields["modificatoDa"] = this.getCurrentUserId();
        }
        return fetch(url, {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    loadNewsAll(idUtente){
        let url = '/api/newsstat/all';
        if (idUtente !== undefined){
            url = url + "/" + idUtente;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }
    loadNewsToday(idUtente){
        let url = '/api/newsstat/today';
        if (idUtente !== undefined){
            url = url + "/" + idUtente;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }
    loadNewsLastWeek(idUtente){
        let url = '/api/newsstat/lastweek';
        if (idUtente !== undefined){
            url = url + "/" + idUtente;
        }
        return fetch(this.getPostUrl(url), {
            method: 'get',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer ' + this.token
            },
        });
    }

    loadNewsViewsByIdNewsAndIdUser(idNews, idUser) {

        let url = this.getPostUrl('/api/newsviews?idNews=' + idNews + '&idUser='+idUser);
        return fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    saveNewsViews(idNews, userId, isVisible){

        let url = '/api/newsviews';
        let method = 'post';
        let fields={
                "idNews": idNews,
                "idUtente": userId,
                "visibile": isVisible
        };
        return fetch(this.getPostUrl(url), {
            method: method,
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    updateNewsViews(fields, id){

        let url = '/api/newsviews';
        return fetch(this.getPostUrl(url), {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    updateNewsViewsByNewsAndUser(idNews, userId, visibile){

        let url = '/api/newsviewsbynewsanduser';
        let fields={
                "idNews": idNews,
                "idUtente": userId,
                "visibile": visibile
        };
        return fetch(this.getPostUrl(url), {
            method: 'patch',
            body: JSON.stringify(fields),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token
            },
        })
    }

    deleteNewsViewsByNews(news) {
        let url = this.getPostUrl('/api/newsviewsbynews/'+news.idNews);
        return fetch(url, {
            method: 'delete',
            headers: {
                authorization: 'Bearer ' + this.token
            }
        })
    }


}

export const client = new Client();


/** WEBPACK FOOTER **
 ** ./src/Client.js
 **/